import Storage from './Storage'
import moment from 'moment'

class WorkflowExecution extends Storage.Vue {

  static get name() {
    return 'workflow_executions'
  }

  constructor(vueOptions) {
    super({
      data: vueOptions,
      computed: {
        name() {
          let now = moment().endOf('day')
          let date = moment(this.run_at)

          let dateString
          if(date.isSame(now, 'day')) {
            dateString = date.format('[Today at] HH:mm')
          } else {
            let dateDiff = now.diff(date, 'days')
            dateString = `${dateDiff} day(s) ago at ${date.format('HH:mm')}`
          }

          return `From ${dateString}`
        }
      },

      methods: {}
    })
  }

  static create(workflowRunner) {
    if (!workflowRunner.workflow.linkedActionUuid) {
      return
    }
    let execution = new WorkflowExecution({workflow_id: workflowRunner.workflow.uuid, output: {}, run_at: (new Date())})
    for (let [outputReference, output] of Object.entries(workflowRunner.workflow.output)) {
      execution.output[output.name] = {
        value: workflowRunner.findPreviousOutput(outputReference),
        action: output.action
      }
    }

    execution.save()

    WorkflowExecution.cleanup()
    return execution
  }

  static cleanup(maxItems=50) {
    let latestRecords = this.storage.allPlain()
    if (latestRecords.length <= maxItems) { return }
    this.storage.replaceAll(latestRecords.reverse().slice(0, maxItems))
  }

}

export default WorkflowExecution